import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { LoginService } from '../../service/login.service';
import { UserService } from '../../service/user.service';
import { NgClass, NgIf, NgStyle } from '@angular/common';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { AlertPopupComponent } from '../popups/alert-popup/alert-popup.component';
import * as zxcvbn from 'zxcvbn';
import { LoaderComponent } from '../../components/loader/loader.component';

@Component({
  selector: 'app-change-password',
  standalone: true,
  imports: [FormsModule, NgIf, NgClass, ReactiveFormsModule, AlertPopupComponent,LoaderComponent],
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.css'
})
export class ChangePasswordComponent implements OnInit {
  oldPassword: string = '';
  newPassword: string = ''
  confirmNewPassword: string = '';
  form!: FormGroup;
  loading = false;
  showOldPassword = false;
  showNewPassword = false;
  showConfirmPassword = false;
  passwordMismatch = false;
  public alertData = { alertMessage: '', alertVisible: '' };
  passwordStrength: number = 0;
  passwordFeedback: string = '';

  constructor(private loginService: LoginService, private userService: UserService, private fb: FormBuilder, private router: Router) {
    this.form = this.fb.group({
      oldPassword: ['', [Validators.required, Validators.minLength(8)]],
      newPassword: ['', [Validators.required, Validators.minLength(8)]],
      confirmNewPassword: ['', [Validators.required, Validators.minLength(8)]],
    });
  }
  ngOnInit(): void {

  }

  @ViewChild('newPasswordInput') newPasswordInput!: ElementRef;
  @ViewChild('confirmPasswordInput') confirmPasswordInput!: ElementRef;
  @ViewChild('SubmitPasswordInput') SubmitPasswordInput!: ElementRef;
  focusNewPassword(event: Event) {
    event.preventDefault();
    setTimeout(() => {
      this.newPasswordInput.nativeElement.focus();
    });
  }

  focusConfirmPassword(event: Event) {
    event.preventDefault();
    setTimeout(() => {
      this.confirmPasswordInput.nativeElement.focus();
    });
  }
  focusSubmitPassword(event: Event) {
    event.preventDefault();
    setTimeout(() => {
      this.SubmitPasswordInput.nativeElement.focus();
    });
  }
  // strengthCheck(password: string): string {
  //   if (!password) return ''; 

  //   const result = (window as any).zxcvbn(password); 
  //   const score = result.score;

  //   let strength = 'Weak'; 
  //   if (score === 3) strength = 'Medium';
  //   else if (score === 4) strength = 'Strong';

  //   return strength;
  // }
  checkNewPassword() {
    const newPasswordControl = this.form.get('newPassword');
    const confirmPasswordControl = this.form.get('confirmNewPassword');
    if (!newPasswordControl?.value && confirmPasswordControl?.value && !newPasswordControl?.touched) {
      newPasswordControl?.markAsTouched();
    }

  }
  strengthCheck(password: string): string {
    if (!password) return '';

    const hasNumber = /\d/.test(password);
    const hasSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]/.test(password);
    const hasAlphabet = /[A-Za-z]/.test(password);
    const isValidLength = password.length >= 8 && password.length <= 15;

    if (!isValidLength) {
      return 'Password should contain at least 8 to 15 Character ';
    }
    // All alphabets
    if (/^[a-zA-Z]+$/.test(password)) {
      return 'Password should contain at least one numeric value';
    }

    // All special characters
    if (/^[^a-zA-Z0-9]+$/.test(password)) {
      return 'Password should contain at least one numeric value';
    }
    // All numericals
    if (/^\d+$/.test(password)) {
      return 'Password should contain at least one special character';
    }
    if (!hasAlphabet) {
      return 'Password should contain at least one character ';
    }
    if (!hasNumber) {
      return 'Password should contain at least one numeric value';
    }

    if (!hasSpecialChar) {
      return 'Password should contain at least one special characters';
    }

    return ''; // No errors, password is valid
  }

  getPasswordStrengthClass(password: string) {
    const strength = this.strengthCheck(password);
    return {
      'weak-password': strength === 'Weak',
      'medium-password': strength === 'Medium',
      'strong-password': strength === 'Strong'
    };
  }
  getPasswordStrengthClasstextbox(password: string) {
    const strength = this.strengthCheck(password);
    return {
      'is-invalid': strength === 'Weak',
      'medium-password-textbox': strength === 'Medium',
      'strong-password-textbox': strength === 'Strong'
    };
  }
  toggleOldPasswordVisibility(): void {
    this.showOldPassword = !this.showOldPassword;
    setTimeout(() => {
      this.showOldPassword = false;
    }, 5000);
  }
  toggleNewPasswordVisibility(): void {
    this.showNewPassword = !this.showNewPassword;
    setTimeout(() => {
      this.showNewPassword = false;
    }, 5000);
  }
  toggleConfirmPasswordVisibility(): void {
    this.showConfirmPassword = !this.showConfirmPassword;
    setTimeout(() => {
      this.showConfirmPassword = false;
    }, 5000);
  }
  onSubmit() {
    const userId = this.userService.getUserId();
    const newPassword = this.form.get('newPassword')?.value;
    const confirmNewPassword = this.form.get('confirmNewPassword')?.value;
    if (this.form.valid) {
      if (this.strengthCheck(newPassword) != '') {
        return;
      }
      if (newPassword !== confirmNewPassword) {
        this.passwordMismatch = true;
        return;
      } else {
        this.passwordMismatch = false;
      }
      this.loading = true;
      this.loginService.ChangePassword(userId, this.form.value.newPassword, this.form.value.oldPassword).subscribe({
        next: (response) => {
          if (response.status === 200) {
            const data = response.body.res;
            if (data == 'Success') {
              this.loading = false;
              this.alertData = { alertMessage: 'Password Changed Successfully', alertVisible: 'success' };

            } else if (data == 'Old Password and New Password should not be same.') {
              this.loading = false;
              this.alertData = { alertMessage: 'New Password can not be same as Old Password. Please enter different password.', alertVisible: 'error' };
            } else if (data == 'Current password you entered is incorrect. Please check.') {
              this.loading = false;
              this.alertData = { alertMessage: 'Current password you entered is incorrect. Please check.', alertVisible: 'error' };
            } else {
              this.loading = false;
              this.alertData = { alertMessage: 'Failed to change password. Please try again.', alertVisible: 'error' };
            }
          } else {
            this.loading = false;
            this.alertData = { alertMessage: 'Failed to change password. Please try again.', alertVisible: 'error' };
          }
        },
        error: (err) => {
          this.loading = false;
          this.alertData = { alertMessage: 'Failed to change password. Please try again.', alertVisible: 'error' };
        }
      });
    } else {
      this.form.markAllAsTouched();
    }
  }

  logOut() {
    sessionStorage.clear();
    localStorage.clear();
    this.router.navigate(['/Login']);
  }
  onClear() {
    this.passwordMismatch = false;
    this.oldPassword = '';
    this.newPassword = '';
    this.confirmNewPassword = '';
    this.form.reset();
    this.form = this.fb.group({
      oldPassword: ['', [Validators.required, Validators.minLength(8)]],
      newPassword: ['', [Validators.required, Validators.minLength(8)]],
      confirmNewPassword: ['', [Validators.required, Validators.minLength(8)]],
    });
    this.form.markAsUntouched();
    this.form.updateValueAndValidity();
    this.showNewPassword = false;
    this.showOldPassword = false;
    this.showConfirmPassword = false;
  }
  closeAlert() {
    if (this.alertData.alertVisible == 'success') {
      this.onClear();
      this.logOut();
    }
    this.alertData = { alertMessage: '', alertVisible: '' };
  }
  goBack() {
    window.history.back();
  }
}
